import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "mainForm",
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('accMgmt.system.headline'),
      "subtitle": _vm.$i18n_t('accMgmt.system.description'),
      "isSaving": _vm.isSaving,
      "formIsValid": _vm.formIsValid,
      "saveButton": ""
    },
    on: {
      "saveData": _vm.saveTheme
    }
  }), _vm.hasLoadedTenants ? _c('div', {
    key: `tenant-${_vm.selectedTenantId}`,
    staticClass: "n20-mainrow pt-4"
  }, [_vm.tenants.length > 1 ? _c('core-n20Card', [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VAutocomplete, {
    staticClass: "px-2",
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.tenants,
      "color": _vm.color,
      "value": _vm.selectedTenantId,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": ""
    },
    on: {
      "input": _vm.selectTenant
    }
  })], 1)], 1) : _vm._e(), !_vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.defaults.maintitle')
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.defaults.maintitleinfo')) + "\n        ")]), _c('h4', {
    staticClass: "px-2 pt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.defaults.title')))]), _vm._l([0], function (j) {
    return _c(VRow, {
      key: `module_skeleton_${j}`,
      staticClass: "my-0 py-0 pt-4",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "4"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1), _c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "4"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1), _c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "4"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1)], 1);
  })], 2) : _vm._e(), _vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.defaults.maintitle')
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.defaults.maintitleinfo')) + "\n        ")]), _c('h4', {
    staticClass: "px-2 pt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.defaults.title')))]), _c(VRow, {
    staticClass: "px-2",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.defaults.uimode'),
      "items": [{
        text: _vm.$i18n_t('accMgmt.system.defaults.uimodes.light'),
        value: 'light'
      }, {
        text: _vm.$i18n_t('accMgmt.system.defaults.uimodes.dark'),
        value: 'dark'
      }],
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.tenantTheme.mode,
      callback: function ($$v) {
        _vm.$set(_vm.tenantTheme, "mode", $$v);
      },
      expression: "tenantTheme.mode"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.defaults.sidebarIconLink'),
      "items": _vm.drawerIconLinks,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "path",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _c(VListItemSubtitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.path)
          }
        })], 1)];
      }
    }], null, false, 3317145841),
    model: {
      value: _vm.tenantTheme.sidebarIconLink,
      callback: function ($$v) {
        _vm.$set(_vm.tenantTheme, "sidebarIconLink", $$v);
      },
      expression: "tenantTheme.sidebarIconLink"
    }
  })], 1)], 1)], 1) : _vm._e(), !_vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.page.title')
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.page.titleInfo')) + "\n        ")]), _vm._l([0, 1, 2, 3], function (j) {
    return _c(VRow, {
      key: `module_skeleton_${j}`,
      staticClass: "my-0 py-0 pt-4",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "12"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1)], 1);
  })], 2) : _vm._e(), _vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.page.title')
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.page.titleInfo')) + "\n        ")]), _c(VTabs, {
    staticClass: "px-4 mt-4"
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-de",
      "justify": "center"
    }
  }, [_c(VAvatar, {
    staticClass: "flag-icon flag-icon-de color-lang",
    staticStyle: {
      "background-size": "132% 100%"
    },
    attrs: {
      "size": "22"
    }
  }), _vm._v("\n              Deutsch\n          ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-en",
      "justify": "center"
    }
  }, [_c(VAvatar, {
    staticClass: "flag-icon flag-icon-gb color-lang",
    staticStyle: {
      "background-size": "132% 100%"
    },
    attrs: {
      "size": "22"
    }
  }), _vm._v("\n              English\n          ")], 1), _vm._l(['de', 'en'], function (l) {
    return _c(VTabItem, {
      key: l,
      attrs: {
        "value": 'tab-' + l
      }
    }, [_c(VRow, {
      staticClass: "mt-2",
      staticStyle: {
        "min-width": "0"
      }
    }, [_c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12"
      }
    }, [_c(VTextField, {
      attrs: {
        "label": _vm.$i18n_t('accMgmt.system.page.pageTitle'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "color": _vm.color,
        "hide-details": ""
      },
      model: {
        value: _vm.tenantTheme['pageTitle' + l.toUpperCase()],
        callback: function ($$v) {
          _vm.$set(_vm.tenantTheme, 'pageTitle' + l.toUpperCase(), $$v);
        },
        expression: "tenantTheme['pageTitle' + l.toUpperCase()]"
      }
    })], 1)], 1), _c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.page.footer')))]), _c(VRow, {
      staticStyle: {
        "min-width": "0"
      }
    }, [_c(VCol, {
      staticClass: "pt-0 pb-2",
      attrs: {
        "cols": "6",
        "md": "6"
      }
    }, [_c(VSwitch, {
      attrs: {
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.defaults.hideFooter'),
        "hide-details": "",
        "inset": ""
      },
      model: {
        value: _vm.tenantTheme.hideFooter,
        callback: function ($$v) {
          _vm.$set(_vm.tenantTheme, "hideFooter", $$v);
        },
        expression: "tenantTheme.hideFooter"
      }
    })], 1), _c(VCol, {
      staticClass: "pt-0 pb-2",
      attrs: {
        "cols": "6",
        "md": "6"
      }
    }, [_c(VSwitch, {
      attrs: {
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.defaults.showFooterPublicDashboard'),
        "hide-details": "",
        "inset": ""
      },
      model: {
        value: _vm.tenantTheme.showFooterPublicDashboard,
        callback: function ($$v) {
          _vm.$set(_vm.tenantTheme, "showFooterPublicDashboard", $$v);
        },
        expression: "tenantTheme.showFooterPublicDashboard"
      }
    })], 1), _c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.page.imprintText'),
        "value": _vm.$i18n_t('Common.drawer.imprint'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "",
        "disabled": ""
      }
    })], 1), _c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.page.imprintLink'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": ""
      },
      model: {
        value: _vm.tenantTheme['footer' + l.toUpperCase()].imprintUrl,
        callback: function ($$v) {
          _vm.$set(_vm.tenantTheme['footer' + l.toUpperCase()], "imprintUrl", $$v);
        },
        expression: "tenantTheme['footer' + l.toUpperCase()].imprintUrl"
      }
    })], 1)], 1), _c(VRow, {
      staticStyle: {
        "min-width": "0"
      }
    }, [_c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.page.aboutUsText'),
        "value": _vm.$i18n_t('Common.drawer.aboutUs'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": "",
        "disabled": ""
      }
    })], 1), _c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.page.aboutUsLink'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": ""
      },
      model: {
        value: _vm.tenantTheme['footer' + l.toUpperCase()].aboutUsUrl,
        callback: function ($$v) {
          _vm.$set(_vm.tenantTheme['footer' + l.toUpperCase()], "aboutUsUrl", $$v);
        },
        expression: "tenantTheme['footer' + l.toUpperCase()].aboutUsUrl"
      }
    })], 1)], 1), _c(VRow, {
      staticStyle: {
        "min-width": "0"
      }
    }, [_c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.page.copyrightText'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": ""
      },
      model: {
        value: _vm.tenantTheme['footer' + l.toUpperCase()].copyrightText,
        callback: function ($$v) {
          _vm.$set(_vm.tenantTheme['footer' + l.toUpperCase()], "copyrightText", $$v);
        },
        expression: "tenantTheme['footer' + l.toUpperCase()].copyrightText"
      }
    })], 1), _c(VCol, {
      staticClass: "py-2",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VTextField, {
      attrs: {
        "color": _vm.color,
        "label": _vm.$i18n_t('accMgmt.system.page.copyrightLink'),
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": ""
      },
      model: {
        value: _vm.tenantTheme['footer' + l.toUpperCase()].copyrightUrl,
        callback: function ($$v) {
          _vm.$set(_vm.tenantTheme['footer' + l.toUpperCase()], "copyrightUrl", $$v);
        },
        expression: "tenantTheme['footer' + l.toUpperCase()].copyrightUrl"
      }
    })], 1)], 1)], 1);
  })], 2)], 1) : _vm._e(), !_vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.page.title')
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.theme.titleInfo')) + "\n        ")]), _vm._l([0], function (j) {
    return _c(VRow, {
      key: `module_skeleton_${j}`,
      staticClass: "my-0 py-0 pt-4",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "12"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "card, list-item"
      }
    })], 1)], 1);
  })], 2) : _vm._e(), _vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.ui.title')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.resetTheme
          }
        }, [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("fal fa-redo")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.reset')) + "\n          ")], 1)];
      },
      proxy: true
    }], null, false, 861643899)
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.ui.titleInfo')))]), _c(VCard, {
    staticClass: "pa-4"
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "6",
      "sm": "6",
      "lg": "4"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "12"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.useAltFonts')))]), _c(VSelect, {
    attrs: {
      "items": [{
        text: 'Vollkorn & Poppins',
        value: false
      }, {
        text: 'Roboto',
        value: true
      }],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.tenantTheme.useAltFonts,
      callback: function ($$v) {
        _vm.$set(_vm.tenantTheme, "useAltFonts", $$v);
      },
      expression: "tenantTheme.useAltFonts"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "12"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.logoByline')))]), _c(VTextField, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: _vm.tenantTheme.lightLogoByline,
      callback: function ($$v) {
        _vm.$set(_vm.tenantTheme, "lightLogoByline", $$v);
      },
      expression: "tenantTheme.lightLogoByline"
    }
  })], 1), _c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "12"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.favoritePageBackground')))]), _c(VSelect, {
    attrs: {
      "items": [{
        text: _vm.$i18n_t('accMgmt.system.theme.favoritePageUseColor'),
        value: false
      }, {
        text: _vm.$i18n_t('accMgmt.system.theme.favoritePageUseImage'),
        value: true
      }],
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.tenantTheme.useCustomBackground,
      callback: function ($$v) {
        _vm.$set(_vm.tenantTheme, "useCustomBackground", $$v);
      },
      expression: "tenantTheme.useCustomBackground"
    }
  })], 1)], 1)], 1), _c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "6",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.favicon')))]), _c('settings-theme-image', {
    ref: "favicon",
    attrs: {
      "imgSrc": _vm.fullImageUrl(_vm.tenantTheme.favicon)
    },
    on: {
      "image:update": _vm.updateFavicon
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.theme.title')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.resetTheme
          }
        }, [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("fal fa-redo")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.reset')) + "\n          ")], 1)];
      },
      proxy: true
    }], null, false, 861643899)
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.titleInfo')))]), _c(VTabs, {
    staticClass: "px-4 mt-4"
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#ui-light"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('accMgmt.system.theme.titleLight')) + "\n          ")]), _c(VTab, {
    attrs: {
      "href": "#ui-dark"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('accMgmt.system.theme.titleDark')) + "\n          ")]), _c(VTabItem, {
    attrs: {
      "value": "ui-light"
    }
  }, [_c(VCard, {
    staticClass: "pa-4",
    attrs: {
      "light": ""
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "4",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.primaryColor')))]), _c('settings-theme-color', {
    attrs: {
      "colors": _vm.colors,
      "color": _vm.tenantTheme.lightHighlight,
      "customerColor": _vm.tenantTheme.lightHighlightCustomer
    },
    on: {
      "input": _vm.setPrimaryColorLight,
      "input:customer": _vm.setPrimaryColorLightCustomer
    }
  }), !_vm.isDefaultLogo(_vm.tenantTheme.lightLogo) || _vm.imageUploads['lightLogo'] ? [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.logoPosition')))]), _c(VSelect, {
    attrs: {
      "items": _vm.bgPositionItems,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.tenantTheme.lightLogoPosition,
      callback: function ($$v) {
        _vm.$set(_vm.tenantTheme, "lightLogoPosition", $$v);
      },
      expression: "tenantTheme.lightLogoPosition"
    }
  })] : _vm._e()], 2), _c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "4",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.logo')))]), _c('settings-theme-image', {
    ref: "lightLogo",
    attrs: {
      "showTransparencyGrid": "",
      "imgSrc": _vm.fullImageUrl(_vm.tenantTheme.lightLogo)
    },
    on: {
      "image:update": _vm.updateLightLogo
    }
  })], 1), _c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "4",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.background')))]), _c('settings-theme-image', {
    ref: "lightBackground",
    attrs: {
      "imgSrc": _vm.fullImageUrl(_vm.tenantTheme.lightBackground)
    },
    on: {
      "image:update": _vm.updateLightBackground
    }
  })], 1)], 1)], 1)], 1), _c(VTabItem, {
    attrs: {
      "value": "ui-dark"
    }
  }, [_c(VCard, {
    staticClass: "pa-4",
    attrs: {
      "dark": ""
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "4",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.primaryColor')))]), _c('settings-theme-color', {
    attrs: {
      "colors": _vm.colors,
      "color": _vm.tenantTheme.darkHighlight,
      "customerColor": _vm.tenantTheme.darkHighlightCustomer
    },
    on: {
      "input": _vm.setPrimaryColorDark,
      "input:customer": _vm.setPrimaryColorDarkCustomer
    }
  }), !_vm.isDefaultLogo(_vm.tenantTheme.darkLogo) || _vm.imageUploads['darkLogo'] ? [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.logoPosition')))]), _c(VSelect, {
    attrs: {
      "items": _vm.bgPositionItems,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "hide-details": ""
    },
    model: {
      value: _vm.tenantTheme.darkLogoPosition,
      callback: function ($$v) {
        _vm.$set(_vm.tenantTheme, "darkLogoPosition", $$v);
      },
      expression: "tenantTheme.darkLogoPosition"
    }
  })] : _vm._e()], 2), _c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "4",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.logo')))]), _c('settings-theme-image', {
    ref: "darkLogo",
    attrs: {
      "dark": "",
      "showTransparencyGrid": "",
      "imgSrc": _vm.fullImageUrl(_vm.tenantTheme.darkLogo)
    },
    on: {
      "image:update": _vm.updateDarkLogo
    }
  })], 1), _c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "4",
      "sm": "6",
      "lg": "4"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.system.theme.background')))]), _c('settings-theme-image', {
    ref: "darkBackground",
    attrs: {
      "dark": "",
      "imgSrc": _vm.fullImageUrl(_vm.tenantTheme.darkBackground)
    },
    on: {
      "image:update": _vm.updateDarkBackground
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), !_vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.page.title')
    }
  }, [_c(VRow, {
    staticClass: "px-4 mt-4 mb-5",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c('p', {
    staticClass: "ml-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('accMgmt.system.email.templates.titleInfo')) + "\n          ")])]), _vm._l([0], function (j) {
    return _c(VRow, {
      key: `module_skeleton_${j}`,
      staticClass: "my-0 py-0 pt-4",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "12"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "list-item, card"
      }
    })], 1)], 1);
  })], 2) : _vm._e(), _vm.selectedTenantId ? _c('core-n20Card', {
    staticClass: "mb-4",
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.email.templates.title')
    }
  }, [_c(VRow, {
    staticClass: "px-4 mt-4 mb-5",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c('p', {
    staticClass: "ml-3"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('accMgmt.system.email.templates.titleInfo')) + "\n          ")]), _c(VCol, {
    staticClass: "pt-1 pb-2",
    attrs: {
      "cols": "12",
      "xl": "6"
    }
  }, [_c(VRow, {
    staticClass: "mb-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VSelect, {
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.email.templates.siteUrl'),
      "items": _vm.getDomains(),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "disabled": _vm.tenantTheme.domains.length <= 1
    },
    model: {
      value: _vm.tenantEmail.siteUrl,
      callback: function ($$v) {
        _vm.$set(_vm.tenantEmail, "siteUrl", $$v);
      },
      expression: "tenantEmail.siteUrl"
    }
  })], 1)], 1), _c(VExpansionPanels, _vm._l(_vm.emailTemplates, function (item, i, idx) {
    return _c(VExpansionPanel, {
      key: `tpl-${idx}`
    }, [_c('settings-email-template', {
      key: `${_vm.selectedTenantId}-${idx}`,
      attrs: {
        "title": i,
        "id": i,
        "subject": item.subject,
        "body": item.html,
        "varsSubject": _vm.emailTplVariables[_vm.convertTemplateKey(i)].subject,
        "varsBody": _vm.emailTplVariables[_vm.convertTemplateKey(i)].body
      },
      on: {
        "update": _vm.updateTemplate
      }
    })], 1);
  }), 1)], 1)], 1)], 1) : _vm._e(), !_vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.feedback.title')
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.feedback.titleInfo')) + "\n        ")]), _vm._l([0], function (j) {
    return _c(VRow, {
      key: `module_skeleton_${j}`,
      staticClass: "my-0 py-0 pt-4",
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "4"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1), _c(VCol, {
      staticClass: "pr-0 mr-0",
      attrs: {
        "cols": "4"
      }
    }, [_c(VSkeletonLoader, {
      attrs: {
        "type": "text"
      }
    })], 1)], 1);
  })], 2) : _vm._e(), _vm.selectedTenantId ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.feedback.title')
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.feedback.titleInfo')) + "\n        ")]), _c(VCol, {
    staticClass: "pl-4 pr-0 d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c(VSwitch, {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": _vm.$i18n_t('Common.customEmail.SwitchLabel'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "inset": ""
    },
    on: {
      "change": function ($event) {
        return _vm.reverseVisibilityCustomEmails();
      }
    },
    model: {
      value: _vm.useCustomEmail,
      callback: function ($$v) {
        _vm.useCustomEmail = $$v;
      },
      expression: "useCustomEmail"
    }
  })], 1), _vm.customEmailsVisible ? _c(VRow, {
    staticClass: "px-2",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.system.feedback.bug'),
      "rules": _vm.emailRules,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.feedback.bug,
      callback: function ($$v) {
        _vm.$set(_vm.feedback, "bug", $$v);
      },
      expression: "feedback.bug"
    }
  })], 1), _c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('accMgmt.system.feedback.featureRequest'),
      "rules": _vm.emailRules,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.feedback.featureRequest,
      callback: function ($$v) {
        _vm.$set(_vm.feedback, "featureRequest", $$v);
      },
      expression: "feedback.featureRequest"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm.selectedTenantId && _vm.isSuperSystemAdmin ? _c('core-n20Card', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.termsAndConditions.title')
    }
  }, [_c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.termsAndConditions.titleInfo')) + "\n        ")]), _c('p', {
    staticClass: "px-4 mt-4"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('accMgmt.system.termsAndConditions.titleInfo2')) + "\n        ")]), _c(VCol, {
    staticClass: "pl-4 pr-0 d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c(VSwitch, {
    staticClass: "ma-0 pa-0",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": _vm.$i18n_t('Common.customTC.SwitchLabel'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "inset": ""
    },
    on: {
      "change": function ($event) {
        return _vm.reverseVisibility();
      }
    },
    model: {
      value: _vm.togglePositionTCC,
      callback: function ($$v) {
        _vm.togglePositionTCC = $$v;
      },
      expression: "togglePositionTCC"
    }
  })], 1), _vm.termsAndConditionsVisible ? _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.customTC.RequestConsent'),
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.requestConsentTermsAndConditions,
      callback: function ($$v) {
        _vm.requestConsentTermsAndConditions = $$v;
      },
      expression: "requestConsentTermsAndConditions"
    }
  })], 1) : _vm._e(), _vm.termsAndConditionsVisible ? _c('core-tenant-terms-and-conditions', {
    attrs: {
      "termsAndConditions": _vm.termsAndConditions
    }
  }) : _vm._e()], 1) : _vm._e(), _c('br'), _c('br')], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };